import type { StateAbbreviation } from '@ria-client/supergraph/marketplace/types';
import { BankingReviewsEyebrow } from './BankingReviewsEyebrow';

export interface PageHeaderProps {
  title: string;
  stateForEyebrow?: StateAbbreviation;
  disclosureSectionTitle?: string;
  showBestOf?: boolean;
}

// 12px/18px/0.8125px: packages/ui/src/Theme/index.ts:1041-1046 accentSmall variant.
const EYEBROW_CLASS_NAME =
  'mb-2 font-sans text-xs leading-normal font-bold uppercase tracking-[0.8125px] text-accent-foreground';

export function PageHeader({
  title,
  stateForEyebrow,
  disclosureSectionTitle,
  showBestOf,
}: PageHeaderProps) {
  return (
    <div>
      {showBestOf && (
        <p className={EYEBROW_CLASS_NAME}>
          best of {!!disclosureSectionTitle && `- ${disclosureSectionTitle}`}
        </p>
      )}
      <BankingReviewsEyebrow stateForEyebrow={stateForEyebrow} />
      <h1 className="typography-xl-headline">{title}</h1>
    </div>
  );
}
